import { localStorageGet, localStorageSet, removeItem } from './index'

const PAGE_FROM_PARAM = 'PAGE_FROM_PARAM'
const PAGE_HASH = 'PAGE_HASH'
const LAST_VIEW_PARAM = 'LAST_VIEW_PARAM'
const MEMBER_INFO = 'MEMBER_INFO'
const TOUR_LOGIN_INFO = 'TOUR_LOGIN_INFO'
const THEME_STORE = 'THEME_STORE'
const STORE_LANGUAGES = 'STORE_LANGUAGES'
const STORE_INFO = 'STORE_INFO'
const SHOPPING_CART = 'SHOPPING_CART'
const MERCHANT_INFO = 'MERCHANT_INFO'
const OWN_STORES = 'OWN_STORES'
const CHAIN_INFO = 'CHAIN_INFO'
const ONLY_DISPLAY = 'ONLY_DISPLAY'

/**********
 * login
 * **********/
export function setLoginInfo(data, expireTime) {
    localStorageSet(TOUR_LOGIN_INFO, data, expireTime)
}
//获登录
export function getLoginInfo() {
    return localStorageGet(TOUR_LOGIN_INFO)
}
//获登录
export function removeLoginInfo() {
    return removeItem(TOUR_LOGIN_INFO)
}

/**
 * 会员信息
 */
export function setMemberInfo(data, expireTime) {
    localStorageSet(MEMBER_INFO, data, expireTime)
}

export function getMemberInfo() {
    return localStorageGet(MEMBER_INFO)
}

export function removeMemberInfo() {
    removeItem(MEMBER_INFO)
}


/*******
 * 来源信息
 */
export function setFromParamStore(data, expireTime) {
    localStorageSet(PAGE_FROM_PARAM, data, expireTime)
}

export function getFromParamStore() {
    return localStorageGet(PAGE_FROM_PARAM)
}

export function removeFromParamStore() {
    removeItem(PAGE_FROM_PARAM)
}

/*******
 * 保存页面
 */
export function setPageHashStore(data, expireTime) {
    localStorageSet(PAGE_HASH, data, expireTime)
}

export function getPageHashStore() {
    return localStorageGet(PAGE_HASH)
}

export function removePageHashStore() {
    removeItem(PAGE_HASH)
}

/*******
 * 保存页面及参数
 */
export function setLastViewParamStore(data, expireTime) {
    localStorageSet(LAST_VIEW_PARAM, data, expireTime)
}

export function getLastViewParamStore() {
    return localStorageGet(LAST_VIEW_PARAM)
}

export function removeLastViewParamStore() {
    removeItem(LAST_VIEW_PARAM)
}



/*******
 * 保存主题
 */
export function setThemeStore(data, expireTime) {
    localStorageSet(THEME_STORE, data, expireTime)
}

export function getThemeStore() {
    return localStorageGet(THEME_STORE)
}

export function removeThemeStore() {
    removeItem(THEME_STORE)
}

/***
 * 门店所支持的语言
 */
export function setStoreLanguages(data, expireTime) {
    localStorageSet(STORE_LANGUAGES, data, expireTime)
}

export function getStoreLanguages() {
    return localStorageGet(STORE_LANGUAGES)
}

export function removeStoreLanguages() {
    removeItem(STORE_LANGUAGES)
}

/*******
 * 保存门店信息
 */
export function setStoreInfo(data, expireTime) {
    localStorageSet(STORE_INFO, data, expireTime)
}

export function getStoreInfo() {
    return localStorageGet(STORE_INFO)
}

export function removeStoreInfo() {
    removeItem(STORE_INFO)
}


/*******
 * 保存购物车信息
 */
export function setShoppingCart(data, storeId, expireTime) {
    const obj = getShoppingCart()
    obj[storeId] = data
    localStorageSet(SHOPPING_CART, obj, expireTime)
}

export function getShoppingCart(storeId) {
    const list = localStorageGet(SHOPPING_CART) || {}
    if (!storeId) return list
    return list[storeId] || []
}

export function removeShoppingCart() {
    removeItem(SHOPPING_CART)
}

/*******
 * 保存商户信息
 */
export function setMerchantInfoStore(data, expireTime) {
    localStorageSet(MERCHANT_INFO, data, expireTime)
}

export function getMerchantInfoStore() {
    return localStorageGet(MERCHANT_INFO)
}

export function removeMerchantInfoStore() {
    removeItem(MERCHANT_INFO)
}

/*******
 * 保存所属门店
 */
export function setOwnStores(data, expireTime) {
    localStorageSet(OWN_STORES, data, expireTime)
}

export function getOwnStores() {
    return localStorageGet(OWN_STORES)
}

export function removeOwnStores() {
    removeItem(OWN_STORES)
}

/*******
 * 保存总店信息
 */
export function setChainInfo(data, expireTime) {
    localStorageSet(CHAIN_INFO, data, expireTime)
}

export function getChainInfo() {
    return localStorageGet(CHAIN_INFO)
}

export function removeChainInfo() {
    removeItem(CHAIN_INFO)
}

/*******
 * 页面只显示功能
 */
export function setOnlyDisplayStore(data, expireTime) {
    localStorageSet(ONLY_DISPLAY, data, expireTime)
}

export function getOnlyDisplayStore() {
    return localStorageGet(ONLY_DISPLAY)
}

export function removeOnlyDisplayStore() {
    removeItem(ONLY_DISPLAY)
}

const BENEFIT_BIND = 'BENEFIT_BIND'

export function setBenefitBind(data, expireTime) {
    localStorageSet(BENEFIT_BIND, data, expireTime)
}

export function getBenefitBind() {
    return localStorageGet(BENEFIT_BIND)
}

export function removeBenefitBind() {
    removeItem(BENEFIT_BIND)
}